import _objectSpread from "H:\\2 - MAV TECNOLOGIA\\REACT-NEW\\Comercial\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "H:\\2 - MAV TECNOLOGIA\\REACT-NEW\\Comercial\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["bsPrefix", "className", "htmlFor"];
import classNames from 'classnames';
import * as React from 'react';
import { useContext } from 'react';
import FormContext from './FormContext';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var FormCheckLabel = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    htmlFor = _ref.htmlFor,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(FormContext),
    controlId = _useContext.controlId;
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check-label');
  return /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: classNames(className, bsPrefix)
  }));
});
FormCheckLabel.displayName = 'FormCheckLabel';
export default FormCheckLabel;